import { render } from "./LeadClientHeader.vue?vue&type=template&id=59f6c6f9"
import script from "./LeadClientHeader.vue?vue&type=script&lang=js"
export * from "./LeadClientHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__